module.exports = __webpack_public_path__ + "img/3-1.e91dc2fc.png";